export enum MESSAGE_CHANNEL {
  INPUT = "input",
  REQUEST = "request",
  SSE = "sse",
}
